import React from "react";
import {NavLink} from "react-router-dom";
import Loader from '../../../components/Loader'
import api from "../../../api/Api";
import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";
import Business from "@material-ui/icons/Business";
import ReactTable from "react-table";
import matchSorter from "match-sorter";
import "react-table/react-table.css";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";

import Button from "components/CustomButtons/Button.jsx";
import {dashboardRouter} from "../../../util/globalHelper"
import Tooltip from "@material-ui/core/Tooltip";

class ClinicRolesList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null
        }

    }

    componentDidMount() {
        this.CallReadApi()
    }

    render() {
        const {classes} = this.props;
        const {data} = this.state;
        if (this.state.data)
            return (<div>
                <Grid container>
                    <GridItem xs={12} sm={12} md={2}>
                        <NavLink to={dashboardRouter("/clinic/role/add")}>
                            <Button block color="warning">
                                <Icon>add</Icon>
                                <span style={{paddingLeft: 10}}>ADD NEW</span>
                            </Button>
                        </NavLink>
                        <br/>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="info" icon>
                                <CardIcon color="info">
                                    <GridContainer>
                                        <GridItem>
                                            <Business/>
                                        </GridItem>
                                        <GridItem style={{marginTop: -2}}>
                                            <h4>Clinic Master Roles</h4>
                                        </GridItem>
                                    </GridContainer>
                                </CardIcon>
                            </CardHeader>
                            <CardBody>
                                <ReactTable
                                    data={data}
                                    filterable
                                    defaultFilterMethod={(filter, row) =>
                                    String(row[filter.id]) === filter.value}
                                    columns={[
                                        {
                                            columns: [
                                                {
                                                    Header: "Name",
                                                    accessor: "clinicmaster_name",
                                                    filterMethod: (filter, rows) =>
                                                        matchSorter(rows, filter.value, {keys: ["clinicmaster_name"]}),
                                                    filterAll: true
                                                },
                                                {
                                                    Header: "Company Number",
                                                    id: "clinicmaster_companynumber",
                                                    accessor: "clinicmaster_companynumber",
                                                    filterMethod: (filter, rows) =>
                                                        matchSorter(rows, filter.value, {keys: ["clinicmaster_companynumber"]}),
                                                    filterAll: true
                                                },
                                                {
                                                    Header: "Admin Name",
                                                    accessor: "clinicmaster_adminname",
                                                    filterMethod: (filter, rows) =>
                                                        matchSorter(rows, filter.value, {keys: ["clinicmaster_adminname"]}),
                                                    filterAll: true
                                                },
                                                {
                                                    Header: "Contact",
                                                    accessor: "clinicmaster_contactinfo",
                                                    filterMethod: (filter, rows) =>
                                                        matchSorter(rows, filter.value, {keys: ["clinicmaster_contactinfo"]}),
                                                    filterAll: true
                                                },
                                                {
                                                    Header: "Actions",
                                                    id: 'request_state',
                                                    filterable: false,
                                                    sortable: false,
                                                    Cell: ({index}) =>
                                                        (<div style={{textAlign: "center"}}>

                                                                <NavLink color="info"
                                                                         to={`/clinic/role/view/${data[index].clinicmaster_id}`}
                                                                         style={{
                                                                             padding: 8,
                                                                             marginLeft: '10%',
                                                                             color: '#39abc1'
                                                                         }}>
                                                                    <Tooltip
                                                                        id="tooltip-top"
                                                                        title="View"
                                                                        placement="bottom">
                                                                        <Icon color="info"
                                                                              style={{fontSize: 30}}>info</Icon>
                                                                    </Tooltip>
                                                                </NavLink>

                                                            </div>
                                                        )
                                                }
                                            ]
                                        }
                                    ]}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                />
                            </CardBody>
                        </Card>
                    </GridItem>
                </Grid>
            </div>)
        else
            return (
                <div>
                    <Loader/>
                </div>
            )
    }

    CallReadApi = () => {
        api.listClinicMaster().then(json => {
            this.setState({data: json.data.data})
        });
    }
}

export default ClinicRolesList


// WEBPACK FOOTER //
// ./src/views/Roles/Clinic/ClinicRolesList.jsx